import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  return (
    <footer className="bg-gray-800 text-white py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          <div className="mb-4 md:mb-0">
            <h3 className="text-xl font-semibold">SMIT LLN</h3>
            <p className="text-gray-400 mt-1">Supporting language, literacy, numeracy, and digital readiness</p>
          </div>
          <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-6">
            <Link to="/privacy-policy" className="text-gray-300 hover:text-white transition">Privacy Policy</Link>
            <Link to="/terms-of-service" className="text-gray-300 hover:text-white transition">Terms of Service</Link>
            <Link to="/contact-us" className="text-gray-300 hover:text-white transition">Contact Us</Link>
          </div>
        </div>
        <div className="mt-6 pt-6 border-t border-gray-700 text-center text-gray-400">
          <p>&copy; {new Date().getFullYear()} SMIT LLN - SMIT. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
